import 'react-app-polyfill/ie11'; // REQUIRED for IE11 polyfills
import 'react-app-polyfill/stable'; // REQUIRED for all other polyfills
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import * as serviceWorker from './serviceWorker';
import App from './App';
import './index.scss';

ReactDOM.render(
	<Router basename={'/'}>
		<App />
	</Router>,
	document.getElementById('paycor-developers-portal')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
